export default __webpack_public_path__ + "static/media/sin_resultados.ccd0198d.svg";